import { z } from 'zod/v4';
// Vendor status
export const VendorStatusSchema = z.enum([
    'active',
    'inactive',
    'suspended',
]);
// Vendor type
export const VendorTypeSchema = z.enum([
    'process-server',
    'courier',
    'skip-trace',
    'research',
    'other',
]);
// Vendor schema - external process servers with contact info
export const VendorSchema = z.object({
    id: z.string().uuid(),
    vendorCode: z.string(), // Short identifier (e.g., "PSV-001")
    name: z.string(),
    companyName: z.string().optional(),
    vendorType: VendorTypeSchema,
    // Contact information
    contactName: z.string().optional(),
    email: z.string().email(),
    phone: z.string().optional(),
    fax: z.string().optional(),
    // Address
    address: z.object({
        street1: z.string(),
        street2: z.string().optional(),
        city: z.string(),
        state: z.string(),
        zip: z.string(),
        country: z.string().default('US'),
    }).optional(),
    // Service regions (states/counties they cover)
    serviceRegions: z.array(z.object({
        state: z.string(),
        counties: z.array(z.string()).optional(), // Empty means all counties
    })).default([]),
    // Licensing
    licenseNumber: z.string().optional(),
    licenseExpiration: z.string().datetime().optional(),
    bondedAmount: z.number().optional(),
    insured: z.boolean().default(false),
    insuranceExpiration: z.string().datetime().optional(),
    // Rates
    standardRate: z.number().optional(),
    rushRate: z.number().optional(),
    // Notes
    notes: z.string().optional(),
    internalNotes: z.string().optional(),
    // Status
    status: VendorStatusSchema.default('active'),
    // Timestamps
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateVendorSchema = VendorSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateVendorSchema = VendorSchema.partial().omit({
    id: true,
    createdAt: true,
});
// Vendor preview for hover displays
export const VendorPreviewSchema = z.object({
    id: z.string().uuid(),
    vendorCode: z.string(),
    name: z.string(),
    vendorType: VendorTypeSchema,
    email: z.string().email(),
    phone: z.string().optional(),
    serviceRegions: z.array(z.string()), // Simplified: just state names
    status: VendorStatusSchema,
});
